import React from 'react';
import {
    TextField,
    Popover,
    DatePicker,
    Icon
} from '@shopify/polaris';
import {
    CalendarMajor
} from '@shopify/polaris-icons';

class DatePickerAttributeFilterField extends React.Component {

    constructor(props) {
        super(props);

        var date = new Date();

        if (props.conditionValue != null) {
            date = new Date(props.conditionValue);
        }

        this.state = {
            popoverActive: false,
            month: date.getMonth(),
            year: date.getFullYear(),
        };
    }

    render() {

        var dateText = this.props.conditionValue;

        if (dateText != null) {
            dateText = dateText.substr(0, 10);
        }

        return (<div data-polaris-layer style={{ position: 'relative', 'z-index': 1 }} >
            <Popover
                sectioned={true}
                active={this.state.popoverActive}
                onClose={() => this.toggleDateActive(false)}
                activator={<TextField placeholder="Date"
                    prefix={<Icon source={CalendarMajor}></Icon>}
                    value={dateText}
                    onFocus={() => this.toggleDateActive(true)}
                    onChange={(newValue) => this.onDateChange(newValue)} />}
            >
                <div>
                    <DatePicker
                        month={this.state.month}
                        year={this.state.year}
                        weekStartsOn={1}
                        selected={new Date(this.props.conditionValue)}
                        onMonthChange={(month, year) => this.onMonthChange(month, year)}
                        onChange={(date) => this.onDateChange(date.start)}
                    />
                </div>
            </Popover>
        </div>);
    }

    toggleDateActive = (active) => {
        this.setState({
            popoverActive: active
        })
    }

    onMonthChange = (month, year) => {
        this.setState({
            month: month,
            year: year
        })
    }

    onDateChange = (newValue) => {
        let utcDate = new Date(Date.UTC(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), 1, 1, 1));
        let formattedValue = utcDate.toISOString().substr(0, 10);

        this.props.onConditionValueChange(formattedValue);
        this.toggleDateActive(false);
    }
}

DatePickerAttributeFilterField.defaultProps = {

}

export default DatePickerAttributeFilterField;